import React, { ChangeEvent } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import _ from 'lodash';
import {
  MobileDesignConfigClasses,
  MobileDesignConfigState,
  MobileDesignSection,
  MobileDesignProduct
} from '../MobileDesignConfig.types';
import { Checkbox, SearchBar, Spinner } from '../..';
import { UNIT } from '../../../constants';

const searchStyle = {
  border: '1px solid #E2E2E2',
  borderRadius: UNIT * 1.5,
  height: UNIT * 2.8125,
  marginBottom: UNIT * 0.5625
};

interface ProductSectionProps {
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  sections: MobileDesignSection[];
  searchTerm: string;
  onSearchChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onApplySearch: (term: string) => void;
  onProductCheck: (product: MobileDesignProduct) => void;
}

const positionStyle = { margin: 10 };

const ProductListSection = ({ classes, state, sections, onProductCheck }: { classes: MobileDesignConfigClasses, state: MobileDesignConfigState, sections: MobileDesignSection[], onProductCheck: (product: MobileDesignProduct) => void }) =>
  _.map(sections, section => {
    const products = Object.values(section.products) as MobileDesignProduct[];
    const selected = products
      .filter(p => state.products[p.key])
      .sort((a, b) => (state.products[a.key]?.position ?? 0) - (state.products[b.key]?.position ?? 0));
    const rest = products
      .filter(p => !state.products[p.key]);
    const sortedProducts = [...selected, ...rest];

    return (
      <li key={section.key}>
        <ListSubheader className={classes.listHeaderStyle}>{section?.name?.toUpperCase()}</ListSubheader>
        {sortedProducts.map(item => {
          const selectedProduct = state.products[item.key];
          const isChecked = Boolean(selectedProduct);
          return (
            <ListItem key={item.key}>
              <Checkbox
                value={isChecked}
                onClick={() => onProductCheck(item)}
                text={item.name}
                className={classes.textStyle}
              />
              {isChecked && selectedProduct?.position !== undefined && (
                <span style={positionStyle}>({selectedProduct.position + 1})</span>
              )}
            </ListItem>
          );
        })}
      </li>
    );
  });

export const ProductSection = ({ classes, state, sections, searchTerm, onSearchChange, onApplySearch, onProductCheck }: ProductSectionProps) => {
  return (
    <>
      <SearchBar
        value={searchTerm}
        label="Chercher un produit..."
        onChange={onSearchChange}
        onBlur={() => onApplySearch(searchTerm)}
        onClick={() => onApplySearch(searchTerm)}
        style={searchStyle}
      />
      {state.isLoadingProducts ? (
        <div className={classes.loadingProduct}>
          <Spinner />
        </div>
      ) : (
        <List className={classes.root} subheader={<li />}>
          <ProductListSection classes={classes} state={state} sections={sections} onProductCheck={onProductCheck} />
        </List>
      )}
    </>
  );
};

